import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Radio from './components/Radio';
import Admin from './components/Admin';
import './styles/layout/App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Radio />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
